import { BlocksPrimaryNavItem } from '@blocks-web-components/components/primary-nav-item/primary-nav-item';
import { BlocksUtilityNavItem } from '@blocks-web-components/components/utility-nav-item/utility-nav-item';

/**
 * Returns focus to the Nav Item with the id provided when using shadow dom.
 * @param {querySelector} string
 */
export const returnFocusToNavItem = (querySelector: string) => {
  type NavItem = BlocksUtilityNavItem | BlocksPrimaryNavItem;
  const navItem: NavItem = document.querySelector(querySelector);

  /*
   * Next line is a hack to avoid having the user pressing
   * TAB twice to move from the UtilityNavItem to the next
   * After closing the drawer.
   */
  if (navItem) {
    navItem.isActive = false;
  }

  const shadowRoot = navItem?.shadowRoot;
  const button = shadowRoot?.querySelector?.('button');

  /*
   * This setTimeout is needed to circumvent a delay added by blocks inside the
   * Drawer's source code that return focus to the drawer after 100ms.
   * See code here:https://github.com/cat-digital-platform/A-Blocks/blob/b50de828a0c44312da7f8344bde4780515e806f3/libs/blocks-v3.0/blocks-web-components/components/drawer/drawer.ts#L246C3-L250C8
   * This only happens when user use keyboard to focus on the X close button
   * inside the drawer and hit ENTER
   * */
  if (button) {
    setTimeout(() => button.focus(), 125);
  }
};
